import { useState } from "react";
import type { AdminAiFeature } from "api/adminApi";
import { NUMERIC } from "pages/admin/ui";
import {
  ACTION_LABEL,
  INPUT_OF,
  LABEL_HELP,
  LOAD_RULES,
  NOT_LOADED,
} from "./aiFormat";

/**
 * 적재 규칙 — 어떤 코치 액션이 어떤 행이 되는지. 목록 위에 접어 두고, 지금 보고 있는 영역 탭의 규칙만 보여준다.
 */
export default function LoadRules({ feature }: { feature: AdminAiFeature }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-slate-500">
        <span>
          코치 액션 로그 기반 파인튜닝 데이터셋 관리 — SFT(messages) ·
          DPO(chosen/rejected) · RL(reference + reward) 샘플 구성.
          <br />
          train/valid/test 분할은 유저 단위로 자동 배정됨.
        </span>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          className="font-medium text-[#0F55A7] hover:underline"
        >
          적재 규칙 {open ? "접기 ▴" : "보기 ▾"}
        </button>
      </div>

      {open && (
        <div className="flex flex-col gap-3 rounded-lg border border-slate-200 bg-white p-4">
          <div className="overflow-x-auto">
            <table className="w-full border-collapse text-sm">
              <thead>
                <tr className="border-b border-slate-200 text-left text-xs text-slate-500">
                  <th className="px-2 py-2 font-semibold">코치 액션 (화면)</th>
                  <th className="px-2 py-2 font-semibold">action</th>
                  <th
                    className="cursor-help px-2 py-2 font-semibold"
                    title={LABEL_HELP}
                  >
                    <span className="border-b border-dotted border-slate-300">
                      라벨
                    </span>
                  </th>
                  <th className="px-2 py-2 font-semibold">AI 출력</th>
                  <th className="px-2 py-2 font-semibold">코치 출력</th>
                  <th className="px-2 py-2 font-semibold">원본 키 · 중복</th>
                  <th className="px-2 py-2 font-semibold">백필</th>
                </tr>
              </thead>
              <tbody>
                {LOAD_RULES[feature].map((rule) => (
                  <tr
                    key={rule.when}
                    className="border-b border-slate-100 align-top last:border-b-0"
                  >
                    <td className="px-2 py-2 text-slate-900">{rule.when}</td>
                    <td className="whitespace-nowrap px-2 py-2">
                      <code className={`text-xs text-slate-700 ${NUMERIC}`}>
                        {rule.action}
                      </code>
                      <span className="ml-1 text-xs text-slate-400">
                        {ACTION_LABEL[rule.action]}
                      </span>
                    </td>
                    <td className="px-2 py-2 text-slate-700">{rule.label}</td>
                    <td className="px-2 py-2 text-slate-500">{rule.ai}</td>
                    <td className="px-2 py-2 text-slate-500">{rule.coach}</td>
                    <td className="px-2 py-2 text-slate-500">{rule.dedupe}</td>
                    <td className="px-2 py-2 text-slate-500">
                      {rule.backfill}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="grid gap-3 text-sm md:grid-cols-2">
            <div>
              <p className="text-xs font-semibold text-slate-500">
                적재 안 하는 것
              </p>
              <ul className="mt-1 list-disc pl-5 text-slate-600">
                {NOT_LOADED[feature].map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
            <div className="flex flex-col gap-1 text-slate-600">
              <p>
                <span className="text-xs font-semibold text-slate-500">
                  입력
                </span>{" "}
                {INPUT_OF[feature]} — 적재 시점 스냅샷. 백필 행은 기준 시각 직전
                내담자 마치기 장면.
              </p>
              <p>
                <span className="text-xs font-semibold text-slate-500">
                  학습 정답
                </span>{" "}
                코치 값, 관리자가 보완하면 보완본 (라벨과는 다르다).
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
